var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGirlLegs6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1160,
    height: 1258,
    viewBox: "0 0 1160 1258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Girl / Legs / 6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shoes"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shoes_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.84 1018.93L120.916 971.231L106.464 918.645L0 1004.13L56.094 1170.62C56.094 1170.62 65.358 1125.53 67.942 1079.05C69.728 1046.93 66.84 1018.93 66.84 1018.93ZM947.327 1104.5C897.569 1088.67 807.547 1130.75 807.547 1130.75L769.015 1148.66L791.413 1209.75L947.327 1104.5Z",
    fill: "#0D0B6D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Skin color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skin",
    d: "M431.568 124.535L478.581 104H497.061L504.92 130.016L554.44 133.717C554.158 126.747 551.276 166.937 536.959 235.951L658.501 637.878L807.541 1130.74L769.021 1148.66C769.021 1148.66 641.381 875.538 534.441 637.878C509.141 581.619 485.002 527.362 463.982 479.183C430.989 562.329 386.076 653.039 324.988 742.479C203.516 920.323 66.8398 1018.93 66.8398 1018.93L45.7998 968.355C45.7998 968.355 329.18 736.297 387.246 121.223L431.568 124.535Z",
    fill: "#E576C6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Skirt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skirt_2",
    d: "M699.4 637.879H226.342C226.342 637.879 258.58 401.299 316.32 244.459C354.62 140.421 389.102 111.241 400.522 104.001H565.762C569.342 112.219 603.682 192.839 640.88 352.339C687.942 554.039 699.4 637.879 699.4 637.879Z",
    fill: "#FCBDA4"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirlLegs6);
export default __webpack_public_path__ + "static/media/Girl-Legs-6.ccc62e04.svg";
export { ForwardRef as ReactComponent };